export const blockIconsAudioandvideoVolumeDownNew = (
	<span className='material-symbols-outlined'>volume_down</span>
);
